export const normalizeWalletId = (walletId: string, type: string) =>
    walletId.startsWith(`${type}-`) ? walletId : `${type}-${walletId}`;
